import { giphyBlue, giphyPink } from '@giphy/js-brand'
import { isObject, map, memoize } from 'lodash'
import { HeaderContext } from 'mobile/components/header/header'
import React, { useContext } from 'react'
import { useHistory } from 'react-router'
import UserContext from 'shared/components/context/user'
import { LoggedInUser } from 'shared/types/user'
import MenuComponent from '../components/menu/menu'
import UserMenu from '../components/menu/user-menu'

const Menu = () => {
    const { menu, setMenuState } = useContext(HeaderContext)
    const { user } = useContext(UserContext)
    const history = useHistory()
    switch (menu) {
        case 'logged out user':
            return (
                <UserMenu
                    color={giphyBlue}
                    items={loggedOutUserItems}
                    itemClick={path => {
                        if (path === '/favorites') {
                            setMenuState(undefined)
                            setTimeout(() => history.push(path), 0)
                        } else {
                            location.href = path
                        }
                    }}
                />
            )
        case 'user':
            return <UserMenu color={giphyBlue} items={userMenuItems(user)} itemClick={path => (location.href = path)} />
        case 'category':
            return <MenuComponent color={giphyPink} items={mainMenuItems()} />
        default:
            return null
    }
}

const loggedOutUserItems = [
    { path: '/login', label: 'Login' },
    { path: '/join', label: 'Join' },
    { path: '/favorites', label: 'Favorites' },
]

const userMenuItems = (user: LoggedInUser) => {
    const { channel, permissions } = user
    const items = [
        {
            path: channel,
            label: 'Channel',
        },
        {
            path: '/favorites',
            label: 'Favorites',
        },
        {
            path: '/logout',
            label: 'Log Out',
        },
    ]

    const gatedItems = [
        {
            path: '/dashboard',
            label: 'Dashboard',
            permission: 'dashboard_link',
        },
    ]

    return [...gatedItems.filter(item => permissions[item.permission]), ...items]
}

const getItem = (prefix: string, joiner = '') => (title: string | object) =>
    isObject(title)
        ? title
        : {
              title,
              link: `${prefix}${encodeURIComponent(title.replace(' ', joiner || ''))}`.toLowerCase(),
          }

const mainMenuItems = memoize(() => [
    {
        header: { title: 'Categories', link: '/categories' },
        items: [
            { title: `GIPHY Studios`, link: `/giphystudios` },
            { title: `Animals`, link: `/categories/animals` },
            { title: `Artists`, link: `/artists` },
            { title: `Emotions`, link: `/categories/emotions` },
            { title: `Entertainment`, link: `/entertainment` },
            { title: `Gaming`, link: `/gaming` },
            { title: `Holidays/Greetings`, link: `/greetings` },
            { title: `Reactions`, link: `/categories/reactions` },
            { title: `Sports`, link: `/sports` },
            { title: `Clips`, link: `/clips` },
        ],
    },
    {
        header: { title: 'Stickers', link: '/stickers' },
        items: map(
            [
                {
                    title: 'Originals',
                    link: '/originals/stickers/studiosoriginalstickers',
                },
                'Trending',
                'Reactions',
                'Packs',
            ],
            getItem('/stickers/', '-')
        ),
    },
    {
        header: { title: 'Apps', link: '/apps' },
        items: map(['GIPHY', 'GIPHY World', 'GIPHY Keys'], getItem('/apps/')),
    },
    {
        header: { title: 'About', link: '/about' },
        items: map(
            [
                'DMCA',
                'FAQ',
                {
                    title: 'Jobs',
                    link: 'https://jobs.giphy.com',
                },
                {
                    title: 'Engineering Blog',
                    link: 'https://engineering.giphy.com/blog/',
                },
                {
                    title: 'GIPHY Arts',
                    link: 'https://arts.giphy.com/',
                },
                {
                    title: 'Community Guidelines',
                    link: '/community-guidelines',
                },
            ],
            getItem('/')
        ),
    },
])

export default Menu
